module.exports = __webpack_public_path__ + "img/icon-light.1dd2ae88.png";